import { Failure } from '@geekbears/gb-ngrx-stack-base';
import { createAction, props } from '@ngrx/store';
import { ApiQueryParams } from '@utils/api-query-params.type';

/**
 * Actions For All Plans
 */
export const getAllPlansAction = createAction(
  '[Membership] Get All Plans Action'
);
export const getAllPlansSuccessAction = createAction(
  '[Membership] Get All Plans Success Action',
  props<{
    membership: any;
  }>()
);
export const getAllPlansFailureAction = createAction(
  '[Membership] Get All Plans Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For All Cards
 */
export const getAllCardsAction = createAction(
  '[Membership] Get All Cards Action',
  props<{
    userId: string;
  }>()
);
export const getAllCardsSuccessAction = createAction(
  '[Membership] Get All Cards Success Action',
  props<{
    cards: any;
  }>()
);
export const getAllCardsFailureAction = createAction(
  '[Membership] Get All Cards Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Delete Card
 */
export const deleteCardAction = createAction(
  '[Membership]  Delete Card Action',
  props<{
    userId: string;
    paymentMethodId: string;
  }>()
);
export const deleteCardSuccessAction = createAction(
  '[Membership]  Delete Card Success Action',
  props<{
    response: any;
  }>()
);
export const deleteCardFailureAction = createAction(
  '[Membership]  Delete Card Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Pay Membership
 */
export const subscribeToPlanAction = createAction(
  '[Membership]  Subscribe To Plan Action',
  props<{
    subscriptionData: {
      _planId: string;
      _userId: string;
      paymentMethodId?: string;
    };
  }>()
);
export const subscribeToPlanSuccessAction = createAction(
  '[Membership]  Subscribe To Plan Success Action',
  props<{
    response: any;
  }>()
);
export const subscribeToPlanFailureAction = createAction(
  '[Membership]  Subscribe To Plan Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Update memberhsip
 */
export const updateMembershipAction = createAction(
  '[Membership]  Update Membership Action',
  props<{
    _subscription: string;
    data: {
      _planId: string;
      _userId: string;
      paymentMethodId?: string;
    };
  }>()
);
export const updateMembershipSuccessAction = createAction(
  '[Membership]  Update Membership Success Action',
  props<{
    response: any;
  }>()
);
export const updateMembershipFailureAction = createAction(
  '[Membership]  Update Membership Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Add Card
 */
export const addCardAction = createAction(
  '[Membership]  Add Card Action',
  props<{
    userId: string;
    token: {
      paymentMethodToken: string;
    };
  }>()
);
export const addCardSuccessAction = createAction(
  '[Membership]  Add Card Success Action',
  props<{
    response: any;
  }>()
);
export const addCardFailureAction = createAction(
  '[Membership]  Add Card Failure Action',
  props<{
    failure: Failure;
  }>()
);

/**
 * Actions For Cancel Membership
 */
export const cancelMembershipAction = createAction(
  '[Membership]  Cancel Membership Action',
  props<{
    _subscription: string;
    _user: string;
  }>()
);
export const cancelMembershipSuccessAction = createAction(
  '[Membership]  Cancel Membership Success Action',
  props<{
    response: any;
  }>()
);
export const cancelMembershipFailureAction = createAction(
  '[Membership]  Cancel Membership Failure Action',
  props<{
    failure: Failure;
  }>()
);

export const MembershipActions = {
  /**
   * Actions For Get All Plans
   */
  getAllPlans: getAllPlansAction,
  getAllPlansSuccess: getAllPlansSuccessAction,
  getAllPlansFailure: getAllPlansFailureAction,

  /**
   * Actions For Get All Cards
   */
  getAllCards: getAllCardsAction,
  getAllCardsSuccess: getAllCardsSuccessAction,
  getAllCardsFailure: getAllCardsFailureAction,

  /**
   * Actions For Delete Card
   */
  deleteCard: deleteCardAction,
  deleteCardSuccess: deleteCardSuccessAction,
  deleteCardFailure: deleteCardFailureAction,

  /**
   * Actions For Pay Membership
   */
  subscribeToPlan: subscribeToPlanAction,
  subscribeToPlanSuccess: subscribeToPlanSuccessAction,
  subscribeToPlanFailure: subscribeToPlanFailureAction,

  /**
   * Actions For Add Card
   */
  addCard: addCardAction,
  addCardSuccess: addCardSuccessAction,
  addCardFailure: addCardFailureAction,

  /**
   * Actions For Update Membership
   */
  updateMembership: updateMembershipAction,
  updateMembershipSuccess: updateMembershipSuccessAction,
  updateMembershipFailure: updateMembershipFailureAction,
  /**
   * Actions For Cancel Membership
   */
  cancelMembership: cancelMembershipAction,
  cancelMembershipSuccess: cancelMembershipSuccessAction,
  cancelMembershipFailure: cancelMembershipFailureAction,
};
